var _excluded = ["height", "width"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';

var IconSendFill = function IconSendFill(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? 32 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 32 : _ref$width,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    width: width,
    height: height
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M27.325 14.129a2.077 2.077 0 010 3.742L5.807 27.832c-1.06.522-2.307-.236-2.307-1.402l.917-7.74a1.582 1.582 0 011.397-1.377l15.098-.909c.585-.06.595-.747 0-.808l-15.098-.91a1.581 1.581 0 01-1.397-1.376L3.5 5.57c0-1.167 1.247-1.924 2.307-1.402l21.518 9.96z",
    clipRule: "evenodd"
  }));
};

IconSendFill.propTypes = process.env.NODE_ENV !== "production" ? {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
} : {};
export default IconSendFill;
//# sourceMappingURL=IconSendFill.js.map